import type { VirtualBackground } from '~/constants/virtual-background'
import { VIRTUAL_BACKGROUND_DEFAULT } from '~/constants/virtual-background'

export interface RoomPreferencesSettings {
  // sidebars
  isSidebarLeft: boolean
  isSidebarRight: boolean

  // sections
  isSectionFaqs: boolean
  isSectionJobDetails: boolean
  isSectionMediaSettings: boolean

  // app
  isHeader: boolean
  isRoomStarted: boolean
  enableOnBoarding: boolean

  // media
  isCamera: boolean
  isMicrophone: boolean
  isMirror: boolean
  isSpeaker: boolean

  // camera
  isVirtualBackground: boolean
  cameraVirtualBackground: VirtualBackground
}

export interface UserPreferencesSettings {
  // TODO: add user preferences types here
}

export interface UserSettings {
  preferences: Partial<UserPreferencesSettings>
}

export interface RoomSettings {
  preferences: Partial<RoomPreferencesSettings>
}

export function getDefaultUserSettings(): UserSettings {
  return {
    preferences: {
      // TODO: add default user preferences here
    },
  }
}

export function getDefaultRoomSettings(): RoomSettings {
  return {
    preferences: {
      isSidebarLeft: false,
      isSidebarRight: false,
      isSectionFaqs: false,
      isSectionJobDetails: false,
      isSectionMediaSettings: false,
      isHeader: true,
      isRoomStarted: false,
      isCamera: true,
      isMicrophone: true,
      isSpeaker: true,
      isMirror: false,
      isVirtualBackground: false,
      cameraVirtualBackground: VIRTUAL_BACKGROUND_DEFAULT,
      enableOnBoarding: true,
    },
  }
}
